import { UsersApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useUsersAPI(): UsersApi {
  return new UsersApi(apiConfig);
}
